import { render, staticRenderFns } from "./Multimedia.vue?vue&type=template&id=2baf61b0&scoped=true&"
import script from "./Multimedia.vue?vue&type=script&lang=js&"
export * from "./Multimedia.vue?vue&type=script&lang=js&"
import style0 from "./Multimedia.vue?vue&type=style&index=0&id=2baf61b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf61b0",
  null
  
)

export default component.exports